<template>
    <div class="member">
        <div style="margin-right: 21px">
            <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 10C19 17 10 23 10 23C10 23 1 17 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z" stroke="#101828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z" stroke="#101828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div style="width: 100%;">
        <div
            v-if="value.logo_url"
            class="member-logo"
            :style="{
                backgroundImage: `url(${value.logo_url})`
            }"
        ></div>

        <h4>{{ value.name }}</h4>
        <p>
            {{ value.address_line1 }}
            <br>
            {{ value.city }}, {{ value.state ? value.state + ', ' : '' }}{{ value.postal_code }}
        </p>

        <p>{{ value.main_phone_number }}</p>

        
        <div class="d-flex flex-row flex-wrap" style="padding: 0.5rem 0 1.5rem 0;">
            <div v-if="value.naid_aaa" class="certification">
                <img src="/wp-content/plugins/isigma-members/img/naid_aaa.png" alt="naid_aaa">
                <span>NAID AAA<br>Certified</span>
            </div>

            <div v-if="value.prism_privacy" class="certification">
                <img src="/wp-content/plugins/isigma-members/img/prism_privacy.png" alt="prism_privacy">
                <span>PRISM Privacy+<br>Certified</span>
            </div>

            <div v-if="value.type === 'industry_supplier'" class="certification">
                <img src="/wp-content/plugins/isigma-members/img/industry_supplier.png" alt="industry_supplier">
                <span>Industry<br>Supplier</span>
            </div>

            <div v-if="value.type === 'member'" class="certification">
                <img src="/wp-content/plugins/isigma-members/img/isigma_member.png" alt="isigma_member">
                <span>i-Sigma<br>Member</span>
            </div>
        </div>
        
        <div class="d-flex flex-row buttons-row">
            <a
                class="isigma_members_btn isigma_members_btn-black"
                :href="`/?rhythm_id=${value.rhythm_id}`"
                target="_blank"
            >
                View Details
            </a>

            <button @click="$emit('showOnMap')" class="isigma_members_btn isigma_members_btn-text">View on Map</button>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Object
    },
    emits: ['showOnMap']
}
</script>

<style scoped>
.member {
    border: 1px solid #D0D5DD;
    padding: 1.5rem 1rem;
    margin-bottom: 1.5rem;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
}

.member.highlighted {
    box-shadow: 2px 2px 5px 0px #d0d5dd8f;
}

.member-logo {
    height: 80px;
    max-width: 220px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid #d0d5dd2a;
    margin-bottom: 18px;
}

#locator-app .member h4 {
    font-family: Arial;
    font-size: 20px;
    font-weight: 700;
    line-height: 23px;
    padding: 0;
    margin-bottom: 0.5rem;
}

#locator-app .member p {
    font-family: Arial;
    font-size: 20px;
    font-weight: 400;
    line-height: 23px;
    text-align: left;
    margin-bottom: 0.5rem;
}


#locator-app .certification {
    display: flex;
    flex-direction: row;
    padding: 4px 12px;
    margin: 0.5rem 0;
    align-items: center
}
#locator-app .certification img {
    height: 32px;
    margin-right: 8px;
}

.buttons-row {
    justify-content: space-between;
}
</style>